module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "contentWrap"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isIndexShowBanner),
      expression: "isIndexShowBanner"
    }],
    staticClass: "slider_container"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "content right"
  }, [_c('CustomAside'), _vm._v(" "), _c('router-view')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../../assets/images/Saipa_banner1_Far.png"),
      "alt": "pure css3 slider"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../../assets/images/Saipa_banner2_Far.png"),
      "alt": "pure css3 slider"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../../assets/images/Saipa_banner3_Far.png"),
      "alt": "pure css3 slider"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6f9e61fb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/private/layout/Layout.vue
// module id = 108
// module chunks = 1